module.exports = __webpack_public_path__ + "img/images_esg_2_11.88ae3bf5.jpg";